/* Bazaar Pro — theme scripts */
(function () {
  'use strict';

  /* Mobile navigation drawer */
  var drawer = document.getElementById('NavDrawer');
  var overlay = document.getElementById('NavOverlay');
  var openers = document.querySelectorAll('[data-drawer-open]');
  var closers = document.querySelectorAll('[data-drawer-close]');

  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    if (overlay) overlay.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }

  openers.forEach(function (el) {
    el.addEventListener('click', function () { setDrawer(true); });
  });
  closers.forEach(function (el) {
    el.addEventListener('click', function () { setDrawer(false); });
  });
  if (overlay) overlay.addEventListener('click', function () { setDrawer(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setDrawer(false);
  });

  /* Product gallery thumbnails */
  var thumbs = document.querySelectorAll('[data-gallery-thumb]');
  var mainImage = document.querySelector('[data-gallery-main]');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainImage) return;
      mainImage.src = thumb.getAttribute('data-full');
      mainImage.alt = thumb.getAttribute('data-alt') || '';
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* Keep the WhatsApp order message in sync with the chosen variant */
  var variantSelect = document.querySelector('[data-variant-select]');
  var waOrder = document.querySelector('[data-wa-order]');
  if (variantSelect && waOrder) {
    var base = waOrder.getAttribute('data-base') || '';
    variantSelect.addEventListener('change', function () {
      var label = variantSelect.options[variantSelect.selectedIndex].text;
      waOrder.href = base + encodeURIComponent('\n' + label);
    });
  }

  /* Cart quantity inputs submit the cart form on change */
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });
})();
